module.exports = __webpack_public_path__ + "img/menu.7fb016af.png";